document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    const gallery = thumb.closest('[id^="DesktopGallery"]')
    const mainImg = gallery.querySelector('[id^="MainImage"]')
    const toggle = gallery.querySelector('.product__media-toggle')

    mainImg.src = thumb.dataset.mediaSrc
    mainImg.alt = thumb.dataset.mediaAlt
    toggle.dataset.mediaId = thumb.dataset.mediaId

    gallery.querySelectorAll('.product-gallery__thumb').forEach(function (thumbEl) {
      thumbEl.classList.remove('product-gallery__thumb--active')
    })
    thumb.classList.add('product-gallery__thumb--active')
  })
})
